<!--
 * @Author: your name
 * @Date: 2021-04-13 13:20:56
 * @LastEditTime: 2021-08-30 09:58:49
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \ecfc-henan-oms-facade-SIT\src\views\home\components\sidebar\index.vue
-->
<template>
    <div class="ec-menu" :class="{'has-logo':showLogo}"  style="">
        <el-scrollbar style="height:100%">
            <el-menu
                :default-active="activeMenu"
                :collapse="isCollapse"
                :unique-opened="true"
                :text-color="variables.menuTxtColor"
                :collapse-transition="false"
                mode="vertical"
            >
                <sidebar-item
                    v-for="(route, index) in sidebarRouters"
                    :key="route.permisUrl  + index"
                    :item="route"
                    :base-path="route.permisUrl"
                />
            </el-menu>
            <!-- <div class="ec-menu__fold" @click="toggleSideBar" style="position:fixed;left:0.7rem;bottom:0px;
            color:rgb(207 228 228)">
              <i :class="isCollapse ?  'el-icon-s-unfold': 'el-icon-s-fold'"></i>
            </div> -->
        </el-scrollbar>
        <!-- <div class="ec-left flex-flex-start"> -->
      <!-- <div class="ec-menu__fold" @click="toggleSideBar">
        <i :class="isCollapse ?  'el-icon-s-unfold': 'el-icon-s-fold'"></i>
      </div> -->
    <!-- </div> -->
    </div>
</template>

<script>
import SidebarItem from "./SidebarItem";
import { mapState } from 'vuex'
import variables from "@/styles/theme/variables.scss";
export default {
    name: 'EcMenu',
    components: { SidebarItem },
    computed: {
        ...mapState({'sidebarRouters': 'permiss', 'isCollapse': 'isCollapse'}),
        activeMenu() {
            const route = this.$route;
            const { meta, path } = route;
            if (meta.activeMenu) {
                return meta.activeMenu
            }
            return path
        },
        showLogo() {
            // return this.$store.state.settings.sidebarLogo;
            return false
        },
        // isCollapse() {
        //     return !this.sidebar.opened;
        //     // return false
        // },
        variables() {
            return variables
        }
    },
    methods:{
      toggleSideBar () {
        this.$store.dispatch('setIsCollapse')
      }
    }
}
</script>
<style lang="scss" scoped>
@import '~@/styles/theme/variables.scss';
.ec-menu {
   height: calc(100% - 74px);
   background: $menuBgColor2;
   ::v-deep .el-submenu {
     .el-menu,
     .el-menu-item {
        background-color: $menuRegionActiveBgColor !important;
     }   
     .el-menu-item:hover{
        background-color: $menuActiveBgColor !important;
     }
     .el-menu-item:focus,
     .el-menu-item.is-active {
        background-color: $menuVisitedBgColor !important;
        font-weight: 600;
     }
   }
}
.hideSideBar{
  .ec-menu {
    ::v-deep .el-submenu{
      .ec-menu__title{
        font-size: $smallFontSize;
        text-align: center;
      }
    }
  }
}

.openSideBar{
  .ec-menu {
    ::v-deep .el-submenu
    .el-submenu__title{
      font-size: $mediumFontSize;
    }
    ::v-deep .el-menu .nest-menu .el-submenu__title{
      background-color:$menuRegionActiveBgColor !important;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/views/home/components/EcMenu/index.vue